import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Import global styles
import '../public/css/color-system.css'

const app = createApp(App)

app.use(store)
app.use(router)

// Set initial page title before mount
router.isReady().then(() => {
  const route = router.currentRoute.value
  if (route.meta.title) {
    document.title = route.meta.title as string
  }
})

app.mount('#app')

// Signal to prerenderer that the app is fully loaded
router.isReady().then(() => {
  document.dispatchEvent(new Event('render-event'))
})
